import { gql } from "@apollo/client"
import { useMemo } from "react"
import { useQuery, UseQueryOptions } from "@oysterhr/core"
import { Query } from "@oysterhr/schema"

export const BENEFITS_PROVIDERS_LIST_QUERY = gql`
  query AllBenefitProvidersList {
    benefitProviders {
      collection {
        id
        descriptiveName
        name
        automated
      }
    }
  }
`

export function useBenefitProviders(
  options?: UseQueryOptions<Pick<Query, "benefitProviders">, never>,
) {
  const { data, ...rest } = useQuery(BENEFITS_PROVIDERS_LIST_QUERY, {
    fetchPolicy: "cache-and-network",
    ...options,
  })

  const providers = useMemo(() => data?.benefitProviders.collection || [], [data])

  return {
    providers,
    ...rest,
  }
}
